
import { Component, Vue } from "vue-property-decorator";
import FormularioLandingComponent from "@/components/Formulario2026/FormularioLandingComponent.vue";

@Component({
  components: {
    FormularioLandingComponent
  }
})
export default class FormularioLandingView extends Vue {}
